/**
 * 应用入口
 * - 指令注册
 * - 过滤器注册
 * - 组件注册
 * - 混入注册
 *
 * 在全局对象上暴露了几个属性
 * - $routerConfig（vue-router实例）
 * - $store（vuex实例）
 * - $route（当前路由对象实例）
 *
 * @since 1.0.0
 * @version 1.0.0
 */
import Vue from 'vue'
import components from './components'
import filters from './filters'
import directives from './directives'
import mixins from './mixins'
import 'assets/styles/main.scss' // ui主题样式
import routerConfig from '@/routes/router.config' // router实例
import store from '@/store' // router实例
import './config/config' // Vue相关业务配置进行注册
import App from './app.vue'
import {
  thirtyDaysBefore,
  thirtyDaysBeforeTime,
  timeFormat,
  today,
  todayEndTime,
  todayStartTime,
  zoomImg,
} from 'utils/index'

import initData from '@/config/initData'
import VueVirtualScroller from 'vue-virtual-scroller'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
//引入样式
import 'swiper/css/swiper.css'
// 自定义组件预览
import '@/components/previewImage/index.js'
// 注册svg
import '@/components/SvgIcon/config'

// 创建 EventBus 实例并挂载到 Vue 原型上
Vue.prototype.$bus = new Vue()

/**
 * 注册vue业务组件/过滤器/指令
 *
 * @param {string} type - 要注册的vue类型
 * @param {object} sets - 要注册的组件选项，键/值对
 */
function register(type, sets) {
  Object.keys(sets).forEach((key) => {
    if (/^mixin$/.test(type)) {
      Vue[type](sets[key])
    } else {
      Vue[type](key, sets[key])
    }
  })
}

// 注册通用组件
register('component', components)

// 注册通用过滤器
register('filter', filters)

// 注册通用指令
Vue.use(directives)

// 注册通用混入
register('mixin', mixins)
Vue.config.productionTip = false

Vue.mixin({
  methods: {
    switchTaskConsole(url, data, showable = true) {
      console.log(
        'store',
        this.$store,
        this.$store._actions,
        this.$store._actions,
        this.$store.state.listAllPerm.showTaskConsoleDrawer
      )
      console.log('store22', this.$store.dispatch)
      this.$store.dispatch('switchTaskConsoleDrawer', showable)
    },
  },
})

Vue.use(VueAwesomeSwiper)
Vue.use(VueVirtualScroller)

Vue.prototype.$timeFormat = timeFormat
Vue.prototype.$today = today
Vue.prototype.$todayStartTime = todayStartTime
Vue.prototype.$todayEndTime = todayEndTime
Vue.prototype.$thirtyDaysBeforeTime = thirtyDaysBeforeTime
Vue.prototype.$thirtyDaysBefore = thirtyDaysBefore
Vue.prototype.$zoomImg = zoomImg

// 最简单的 hash 检查自动刷新方案
function getCurrentBuildHash() {
  return document.querySelector('meta[name="git-commit"]')?.getAttribute('content')
}

let currentHash = getCurrentBuildHash()

function checkHashAndReload() {
  fetch('/index.html?_t=' + Date.now())
    .then((res) => res.text())
    .then((html) => {
      const match = html.match(/<meta name="git-commit" content="(.*?)"/)
      if (match && match[1] && match[1] !== currentHash) {
        window.location.reload(true) // hash 变了，强制刷新
      }
    })
}
window.addEventListener('unhandledrejection', (event) => {
  console.log('event----------------------test', event.reason)
  const { name } = event?.reason || {}
  console.log('name', name)
  if (name.includes('ChunkLoadError')) {
    checkHashAndReload()
  }
})

initData().then((r) => {
  new Vue({
    router: routerConfig,
    store,
    render: (h) => h(App),
  }).$mount('#app')
})
